import { Component, OnInit } from '@angular/core';
import { InfoProfileService } from '../info-profile.service';

@Component({
  selector: 'app-context',
  templateUrl: './context.component.html',
  styleUrls: ['./context.component.css']
})

export class ContextComponent implements OnInit {
  currentContext : number;
  contexts : Array<string>;
  infoLocation : string;
  SystemView: string;
  SystemsOptionsDescription: string;
  contextChange: string;

  constructor(){ }

  ngOnInit() {
  }
}
